import React, { useState, useEffect } from 'react'
import { Editor } from '@monaco-editor/react'

const CodeSnippet:React.FC<{
  question: string;
  codeSnippet: string;
  language?: string;
}> = ({ question, codeSnippet, language = 'javascript' }) => {
  const displayLanguage = language && language.trim() !== '' ? language : 'plaintext';
  
  // Dynamic font size based on screen size
  const [fontSize, setFontSize] = useState(9);

  useEffect(() => {
    const updateFontSize = () => {
      const width = window.innerWidth;
      if (width >= 1280) {
        setFontSize(14); // xl
      } else if (width >= 1024) {
        setFontSize(11); // lg
      } else {
        setFontSize(9); // md and below
      }
    };

    updateFontSize();
    window.addEventListener('resize', updateFontSize);
    return () => window.removeEventListener('resize', updateFontSize);
  }, []);

  return (
    <div className='w-full h-full flex flex-col bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden'>
      <div className="px-4 py-3 bg-linear-to-r from-gray-50 to-gray-100/50 border-b border-gray-200 shrink flex items-center justify-between">
        <span className="md:text-xs lg:text-sm xl:text-[15px] text-sm leading-relaxed text-gray-800 font-medium">
          {question}
        </span>
      </div>
      <div className="bg-white flex-1 min-h-0 px-4 [&_.monaco-editor_.view-lines]:select-none">
        <Editor
          value={codeSnippet}
          language={displayLanguage}
          theme="light"
          options={{ 
            readOnly: true,
            domReadOnly: true,
            padding: { top: 16, bottom: 16 },
            minimap: { enabled: false },
            lineNumbers: "off",
            lineNumbersMinChars: 0,
            lineDecorationsWidth: 0,
            glyphMargin: false,
            folding: false,
            scrollBeyondLastLine: false,
            renderLineHighlight: "none",
            overviewRulerLanes: 0,
            hideCursorInOverviewRuler: true,
            overviewRulerBorder: false,
            scrollbar: {
              vertical: "auto",
              horizontal: "auto",
              verticalScrollbarSize: 8,
              horizontalScrollbarSize: 8,
            },
            fontFamily: "'JetBrains Mono', 'Fira Code', 'Consolas', 'Monaco', monospace",
            fontSize: fontSize,              
            lineHeight: 1.6,
            selectionHighlight: false,
            occurrencesHighlight: 'off',
            cursorStyle: 'line-thin',
            cursorBlinking: 'solid',
            renderValidationDecorations: 'off',
            quickSuggestions: false,
            parameterHints: { enabled: false },
            suggestOnTriggerCharacters: false,
            acceptSuggestionOnEnter: 'off',
            tabCompletion: 'off',
            wordBasedSuggestions: 'off',
            selectionClipboard: false,
            contextmenu: false,
            mouseWheelZoom: false,
            links: false,
            hover: { enabled: false },
          }}
          height="100%"
        />
      </div>
    </div>
  )
}

export default CodeSnippet